import { cva } from 'class-variance-authority';
const textareaBase = 'flex w-full min-w-0 rounded-md border border-input bg-background px-3 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/40 dark:aria-invalid:ring-destructive/40 md:text-sm resize-y';
/** min-h·패딩 밀도. default는 md 별칭. */
const textareaSizeMap = {
    default: 'min-h-16 py-2',
    md: 'min-h-16 py-2',
    sm: 'min-h-14 py-1.5 text-sm',
    lg: 'min-h-20 py-2.5',
};
export const textareaCva = {
    variants: {
        size: textareaSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const textareaVariants = cva(textareaBase, textareaCva);
export const textareaSizeKeys = Object.keys(textareaCva.variants.size);
/** 레거시 — default size 클래스 문자열. */
export const textareaClassName = textareaVariants({ size: 'default' });
//# sourceMappingURL=textarea.cva.js.map